<!-- @format -->

<template>
  <el-dialog :title="$t('editOwnerMember.title')" :visible.sync="dialogVisible" width="60%" @close="_closeEditOwnerMemberModal">
    <el-form :model="editOwnerMemberInfo" :rules="rules" ref="form" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('editOwnerMember.personRole')" prop="personRole">
            <el-select v-model="editOwnerMemberInfo.personRole" :placeholder="$t('editOwnerMember.placeholder.personRole')" class="w100">
              <el-option v-for="item in roleOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('editOwnerMember.name')" prop="name">
            <el-input v-model.trim="editOwnerMemberInfo.name" :placeholder="$t('editOwnerMember.placeholder.name')" clearable />
          </el-form-item>

          <el-form-item :label="$t('editOwnerMember.link')" prop="link">
            <el-input v-model.trim="editOwnerMemberInfo.link" :placeholder="$t('editOwnerMember.placeholder.link')" clearable maxlength="11" />
          </el-form-item>

          <el-form-item :label="$t('editOwnerMember.sex')" prop="sex" v-if="editOwnerMemberInfo.personType === 'P'">
            <el-select v-model="editOwnerMemberInfo.sex" :placeholder="$t('editOwnerMember.placeholder.sex')" class="w100">
              <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('editOwnerMember.address')">
            <el-input v-model.trim="editOwnerMemberInfo.address" :placeholder="$t('editOwnerMember.placeholder.address')" clearable />
          </el-form-item>
        </el-col>

        <el-col :span="12" class="text-center">
          <div class="avatar-uploader" v-if="editOwnerMemberInfo.ownerPhotoUrl == '' && hasCamera">
            <!-- 摄像头预览 -->
            <video ref="video" autoplay playsinline width="320" height="160"></video>
            <!-- 拍下来的照片预览 -->
            <canvas ref="canvas" style="display: none"></canvas>
          </div>
          <div class="avatar-uploader" v-else>
            <img v-if="editOwnerMemberInfo.ownerPhotoUrl" :src="editOwnerMemberInfo.ownerPhotoUrl" class="avatar" :alt="$t('editOwnerMember.photo')" @error="handleImageError" />
            <img v-else src="/img/noPhoto.jpg" class="avatar" :alt="$t('editOwnerMember.photo')" />
          </div>
          <el-button v-show="hasCamera" type="primary" icon="el-icon-camera" class="mt10" @click="takePhoto">
            {{ $t("addOwnerMember.takePhoto") }}
          </el-button>
          <el-button type="primary" class="mt10" @click="_uploadEditMemberPhoto">
            {{ $t("editOwnerMember.uploadPhoto") }}
          </el-button>
          <input type="file" ref="fileInput" accept=".jpg,.jpeg,.png" @change="_chooseEditMemberPhoto" style="display: none" />
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('editOwnerMember.concactLink')">
            <el-input v-model.trim="editOwnerMemberInfo.concactLink" :placeholder="$t('editOwnerMember.placeholder.concactLink')" clearable />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('editOwnerMember.idCard')">
            <el-input v-model.trim="editOwnerMemberInfo.idCard" :placeholder="$t('editOwnerMember.placeholder.idCard')" clearable />
          </el-form-item>

          <el-form-item :label="$t('editOwnerMember.remark')">
            <el-input v-model.trim="editOwnerMemberInfo.remark" :placeholder="$t('editOwnerMember.placeholder.remark')" clearable />
          </el-form-item>
        </el-col>
      </el-row>

      <template v-for="(item, index) in editOwnerMemberInfo.attrs">
        <el-row :gutter="20" v-if="index % 2 === 0" :key="index">
          <el-col :span="12">
            <el-form-item :label="item.specName" v-if="item.specType === '2233'">
              <el-input v-model="item.value" :placeholder="item.specHoldplace" clearable />
            </el-form-item>

            <el-form-item :label="item.specName" v-if="item.specType === '3344'">
              <el-select v-model="item.value" :placeholder="item.specHoldplace" class="w100">
                <el-option v-for="value in item.values" :key="value.value" :label="value.valueName" :value="value.value" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="index < editOwnerMemberInfo.attrs.length - 1">
            <el-form-item :label="editOwnerMemberInfo.attrs[index + 1].specName" v-if="editOwnerMemberInfo.attrs[index + 1].specType === '2233'">
              <el-input v-model="editOwnerMemberInfo.attrs[index + 1].value" :placeholder="editOwnerMemberInfo.attrs[index + 1].specHoldplace" clearable />
            </el-form-item>

            <el-form-item :label="editOwnerMemberInfo.attrs[index + 1].specName" v-if="editOwnerMemberInfo.attrs[index + 1].specType === '3344'">
              <el-select v-model="editOwnerMemberInfo.attrs[index + 1].value" :placeholder="editOwnerMemberInfo.attrs[index + 1].specHoldplace" class="w100">
                <el-option v-for="value in editOwnerMemberInfo.attrs[index + 1].values" :key="value.value" :label="value.valueName" :value="value.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="_closeEditOwnerMemberModal">{{ $t("common.cancel") }}</el-button>
      <el-button type="primary" @click="editOwnerMemberMethod">{{ $t("common.save") }}</el-button>
    </div>

    <el-dialog title="裁剪照片" :visible.sync="cropperVisible" width="560px" append-to-body @close="_closeCropper">
      <div class="cropper-wrap" v-if="cropperImg">
        <vue-cropper
          ref="cropper"
          :img="cropperImg"
          :output-size="1"
          output-type="jpeg"
          :auto-crop="true"
          :auto-crop-width="320"
          :auto-crop-height="320"
          :fixed="true"
          :fixed-number="[1, 1]"
          :fixed-box="true"
          :center-box="true"
          :can-scale="true"
          :can-move-box="true"
          :enlarge="2.5"
          :info="true"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cropperVisible = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :loading="cropperLoading" @click="_confirmCropper">{{ $t("common.save") }}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getCommunityId } from "@/api/community/communityApi";
import { getAttrSpecList } from "@/api/dev/attrSpecApi";
import { getAttrValueList } from "@/api/dev/attrValueApi";
import { editOwnerMember } from "@/api/owner/addOwnerMemberApi";
import { editOwner } from "@/api/owner/ownerApi";

import { uploadFile } from "@/api/staff/addStaffApi";
import { VueCropper } from "vue-cropper";

export default {
  name: "EditOwnerMember",
  components: {
    VueCropper,
  },
  data() {
    return {
      dialogVisible: false,
      cropperVisible: false,
      cropperImg: "",
      cropperFileName: "",
      cropperSource: "",
      cropperLoading: false,
      editOwnerMemberInfo: {
        ownerId: "",
        memberId: "",
        ownerTypeCd: "",
        name: "",
        link: "",
        address: "",
        sex: "",
        remark: "",
        ownerPhoto: "",
        ownerPhotoUrl: "",
        idCard: "",
        personType: "P",
        personRole: "1",
        concactLink: "",
        attrs: [],
        isOwnerSelf: false,
      },
      roleOptions: [
        { value: "2", label: this.$t("editOwnerMember.role.tenant") },
        { value: "3", label: this.$t("editOwnerMember.role.family") },
        { value: "4", label: this.$t("editOwnerMember.role.staff") },
        { value: "99", label: this.$t("editOwnerMember.role.other") },
      ],
      sexOptions: [
        { value: "0", label: this.$t("common.male") },
        { value: "1", label: this.$t("common.female") },
      ],
      rules: {
        personRole: [{ required: true, message: this.$t("editOwnerMember.placeholder.personRole"), trigger: "change" }],
        name: [{ required: true, message: this.$t("editOwnerMember.placeholder.name"), trigger: "blur" }],
        link: [
          { required: true, message: this.$t("editOwnerMember.placeholder.link"), trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t("editOwnerMember.validate.phoneFormat"), trigger: "blur" },
        ],
        sex: [{ required: true, message: this.$t("editOwnerMember.placeholder.sex"), trigger: "change" }],
        idCard: [{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: this.$t("editOwnerMember.validate.idCardFormat"), trigger: "blur" }],
        remark: [{ max: 200, message: this.$t("editOwnerMember.validate.remarkLength"), trigger: "blur" }],
      },
      stream: null, // 摄像头视频流
      hasCamera: false, // 是否支持摄像头
    };
  },
  methods: {
    loadImageFromBlob(blob) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(blob)
        const img = new Image()
        img.onload = () => {
          URL.revokeObjectURL(url)
          resolve(img)
        }
        img.onerror = (e) => {
          URL.revokeObjectURL(url)
          reject(e)
        }
        img.src = url
      })
    },
    canvasToJpegBlob(canvas, quality) {
      return new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), 'image/jpeg', quality)
      })
    },
    async createSquareImageCanvas(file, dimension) {
      const img = await this.loadImageFromBlob(file)
      const canvas = document.createElement('canvas')
      canvas.width = dimension
      canvas.height = dimension

      const ctx = canvas.getContext('2d')
      const iw = img.naturalWidth || img.width
      const ih = img.naturalHeight || img.height
      const scale = Math.max(dimension / iw, dimension / ih)
      const sw = dimension / scale
      const sh = dimension / scale
      const sx = Math.max(0, (iw - sw) / 2)
      const sy = Math.max(0, (ih - sh) / 2)

      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, dimension, dimension)
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, dimension, dimension)
      return canvas
    },
    padBlobToMinBytes(blob, minBytes) {
      if (!blob || blob.size >= minBytes) return blob
      return new Blob([blob, new Uint8Array(minBytes - blob.size)], { type: 'image/jpeg' })
    },
    async compressJpegFile(file, { minBytes = 40 * 1024, maxBytes = 100 * 1024, dimension = 800 } = {}) {
      if (!file || !(file instanceof Blob)) return file

      const canvas = await this.createSquareImageCanvas(file, dimension)
      const qualities = [0.98, 0.94, 0.9, 0.86, 0.82, 0.78, 0.74, 0.7, 0.64, 0.58, 0.52, 0.46, 0.4, 0.34, 0.28, 0.22, 0.16, 0.1, 0.06, 0.02]
      let finalBlob = null
      let smallestBlob = null

      for (const quality of qualities) {
        const blob = await this.canvasToJpegBlob(canvas, quality)
        if (!blob || !blob.size) continue
        smallestBlob = blob
        if (blob.size <= maxBytes) {
          finalBlob = blob
          break
        }
      }

      finalBlob = finalBlob || smallestBlob || file
      finalBlob = this.padBlobToMinBytes(finalBlob, minBytes)
      const name = typeof file.name === 'string' && file.name ? file.name.replace(/\.[^/.]+$/, '') + '.jpg' : 'photo.jpg'
      return new File([finalBlob], name, { type: 'image/jpeg' })
    },
    // 初始化摄像头
    async startCamera() {
      try {
        // 基础兼容性判断
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.$message && this.$message.error("当前浏览器不支持摄像头调用");
          return;
        }

        // 先检测当前设备是否存在摄像头
        if (!navigator.mediaDevices.enumerateDevices) {
          // 某些非常老的浏览器没有 enumerateDevices，只能直接尝试 getUserMedia
          this.$message && this.$message.warning("无法检测摄像头设备，直接尝试打开摄像头");
        } else {
          const devices = await navigator.mediaDevices.enumerateDevices();
          const hasCamera = devices.some((d) => d.kind === "videoinput");

          if (!hasCamera) {
            // this.$message && this.$message.error("未检测到摄像头设备");
            this.hasCamera = false;
            return;
          }
        }

        // 注意：video 在 template 里被 v-if 控制，必须等 DOM 渲染出来再取 ref。
        // 第一次可能因为权限弹窗很慢“刚好没问题”，第二次 getUserMedia 很快就会踩到这里。
        this.hasCamera = true;
        await this.$nextTick();

        // 请求摄像头权限（可根据需求设置前后摄像头）
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" }, // 前置可用 'user'
          audio: false,
        });

        const video = this.$refs.video;
        if (!video) {
          // 理论上不应发生：兜底避免抛 TypeError 被当成“权限/设备问题”。
          console.warn("video ref 未就绪，无法挂载摄像头流");
          return;
        }

        if ("srcObject" in video) {
          video.srcObject = this.stream;
        } else {
          // 旧浏览器兼容
          video.src = window.URL.createObjectURL(this.stream);
        }
        video.play();
      } catch (err) {
        console.error("打开摄像头失败", err);

        // 根据错误类型给更友好的提示
        if (err.name === "NotFoundError" || err.name === "OverconstrainedError") {
          this.$message && this.$message.error("未检测到可用的摄像头");
        } else if (err.name === "NotAllowedError" || err.name === "SecurityError") {
          this.$message && this.$message.error("摄像头权限被拒绝，请在浏览器中开启权限");
        } else {
          this.$message && this.$message.error("打开摄像头失败，请检查设备和权限");
        }
      }
    },
    stopCamera() {
      // 1. 停止所有 track
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }

      // 2. 清理 video
      const video = this.$refs.video;
      if (video) {
        if ("srcObject" in video) {
          video.srcObject = null;
        } else {
          video.src = "";
        }
        video.pause && video.pause();
      }
    },
    // 拍照 / 重新拍照
    takePhoto() {
      // 若当前已经有照片：点击“拍照”= 重新拍照（清空旧图 -> 展示预览 -> 重启摄像头）
      if (this.editOwnerMemberInfo.ownerPhotoUrl) {
        if (!this.hasCamera) return;

        this.editOwnerMemberInfo.ownerPhoto = "";
        this.editOwnerMemberInfo.ownerPhotoUrl = "";

        // 允许重复选择同一文件（上传照片后也可再选同一张）
        if (this.$refs.fileInput) this.$refs.fileInput.value = "";

        // 先停再启，避免部分浏览器占用摄像头导致 getUserMedia 失败
        this.stopCamera();
        this.$nextTick(() => this.startCamera());
        return;
      }

      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      if (!video || !canvas) return;

      const vw = video.videoWidth;
      const vh = video.videoHeight;
      if (!vw || !vh) {
        console.warn("无法获取视频分辨率");
        return;
      }

      const maxSize = 1080; // 限制最大宽高

      // 计算等比例缩放比例，保证宽高都不超过 1080
      const scale = Math.min(maxSize / vw, maxSize / vh, 1);

      const targetW = Math.round(vw * scale);
      const targetH = Math.round(vh * scale);

      // 设置 canvas 的内部绘制尺寸（真实图片尺寸）
      canvas.width = targetW;
      canvas.height = targetH;

      const ctx = canvas.getContext("2d");
      // 把当前视频帧画到指定大小
      ctx.drawImage(video, 0, 0, targetW, targetH);

      // 转成 Blob
      canvas.toBlob(
        (blob) => {
          if (!blob) return;
          // 如果 _doUploadImage 需要 File：
          const file = new File([blob], "photo.jpg", { type: "image/jpeg" });
          this.stopCamera(); // 拍照后停止摄像头
          this._openCropper(file, "camera");
        },
        "image/jpeg",
        0.8
      );
    },

    open(member) {
      this.editOwnerMemberInfo = {
        ...member,
        ownerPhoto: member.faceUrl,
        ownerPhotoUrl: member.faceUrl,
        attrs: [],
        isOwnerSelf: !!member.isOwnerSelf,
      };

      this._loadEditOwnerMemberAttrSpec().then(() => {
        if (Object.prototype.hasOwnProperty.call(member, "ownerAttrDtos")) {
          const ownerAttrDtos = member.ownerAttrDtos;
          this.editOwnerMemberInfo.attrs.forEach((attrItem) => {
            ownerAttrDtos.forEach((item) => {
              if (item.specCd === attrItem.specCd) {
                attrItem.attrId = item.attrId;
                attrItem.value = item.value;
              }
            });
          });
        }

        this.dialogVisible = true;
        this.$nextTick(async () => {
          this.$refs.form.clearValidate();
          await this.startCamera();
        });
      });
    },

    editOwnerMemberMethod() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            ...this.editOwnerMemberInfo,
            communityId: getCommunityId(),
          };

          const request = this.editOwnerMemberInfo.isOwnerSelf ? editOwner(params) : editOwnerMember(params);

          request
            .then((res) => {
              if (res.code === 0) {
                this.$message.success(this.$t("common.operationSuccess"));
                this.dialogVisible = false;
                this.$emit("success");
              } else {
                this.$message.error(res.msg || this.$t("common.saveFailed"));
              }
            })
            .catch((err) => {
              console.error("请求失败:", err);
              this.$message.error(this.$t("common.saveFailed"));
            });
        }
      });
    },

    _loadEditOwnerMemberAttrSpec() {
      return new Promise((resolve) => {
        this.editOwnerMemberInfo.attrs = [];
        getAttrSpecList({ page: 1, row: 100, tableName: "building_owner_attr" }).then((data) => {
          data.data.forEach((item) => {
            if (item.specShow === "Y") {
              item.value = "";
              item.values = [];
              this._loadEditMemberAttrValue(item.specCd, item.values);
              this.editOwnerMemberInfo.attrs.push(item);
            }
          });
          resolve();
        });
      });
    },

    _loadEditMemberAttrValue(specCd, values) {
      getAttrValueList({ specCd: specCd, page: 1, row: 100 }).then((data) => {
        data.data.forEach((item) => {
          if (item.valueShow === "Y") {
            values.push(item);
          }
        });
      });
    },

    _uploadEditMemberPhoto() {
      this.$refs.fileInput.click();
    },

    _chooseEditMemberPhoto(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (file.size > 1024 * 1024 * 2) {
          this.$message.error(this.$t("editOwnerMember.validate.photoSize"));
          event.target.value = "";
          return;
        }

        this._openCropper(file, "upload");
        event.target.value = "";
      }
    },

    _openCropper(file, source) {
      if (!file) return;
      this._revokeCropperImg();
      this.cropperFileName = file.name || "photo.jpg";
      this.cropperSource = source || "";
      this.cropperImg = URL.createObjectURL(file);
      this.cropperVisible = true;
    },

    _revokeCropperImg() {
      if (this.cropperImg && this.cropperImg.indexOf("blob:") === 0) {
        URL.revokeObjectURL(this.cropperImg);
      }
      this.cropperImg = "";
    },

    _closeCropper() {
      const source = this.cropperSource;
      this._revokeCropperImg();
      this.cropperFileName = "";
      this.cropperSource = "";
      this.cropperLoading = false;

      if (source === "camera" && !this.editOwnerMemberInfo.ownerPhotoUrl) {
        this.$nextTick(() => this.startCamera());
      }
    },

    _confirmCropper() {
      if (this.cropperLoading || !this.$refs.cropper) return;

      const source = this.cropperSource;
      const fileName = this.cropperFileName || "photo.jpg";
      this.cropperLoading = true;

      this.$refs.cropper.getCropBlob(async (blob) => {
        try {
          if (!blob) return;

          const name = fileName.replace(/\.[^/.]+$/, "") + ".jpg";
          const file = new File([blob], name, { type: "image/jpeg" });

          this.cropperSource = "";
          this.cropperFileName = "";
          this.cropperVisible = false;
          this._revokeCropperImg();

          await this._doUploadImageEditOwnerMember(file);
        } catch (err) {
          console.error("裁剪失败:", err);
          this.$message.error(this.$t("editOwnerMember.uploadFailed"));
          if (source === "camera" && !this.editOwnerMemberInfo.ownerPhotoUrl) {
            this.$nextTick(() => this.startCamera());
          }
        } finally {
          this.cropperLoading = false;
        }
      });
    },

    async _doUploadImageEditOwnerMember(file) {
      try {
        const compressedFile = await this.compressJpegFile(file, { minBytes: 40 * 1024, maxBytes: 100 * 1024, dimension: 800 })
        const formData = new FormData()
        formData.append('uploadFile', compressedFile)
        formData.append('communityId', getCommunityId())

        const res = await uploadFile(formData)
        this.editOwnerMemberInfo.ownerPhoto = res.fileId
        this.editOwnerMemberInfo.ownerPhotoUrl = res.url
      } catch (err) {
        console.error('上传失败:', err)
        this.$message.error(this.$t('editOwnerMember.uploadFailed'))
      }
    },

    _closeEditOwnerMemberModal() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.stopCamera();
      this._revokeCropperImg();
    },

    handleImageError(e) {
      e.target.src = "/img/noPhoto.jpg";
    },
  },
};
</script>

<style scoped>
.w100 {
  width: 100%;
}

.mt10 {
  margin-top: 10px;
}

.text-center {
  text-align: center;
}

.avatar-uploader {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.avatar {
  width: 150px;
  height: 150px;
  object-fit: cover;
}

.cropper-wrap {
  width: 100%;
  height: 360px;
}
</style>
